import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { OrderSteps } from 'components/OrderSteps';
import { Layout } from 'features/Layouts/Layouts';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setInfoOrderDetail } from 'redux/ordersDetails/slice';
import { RootState } from 'redux/store';
import { ReactComponent as BackBtn } from './img/iconChewronForward.svg';
import styles from './CreateOrder.module.scss';
import { useOrderSubmission } from './hooks/useOrderSubmission';
import { useOrderValidation } from './hooks/useOrderValidation';
import { CreateOrderForm } from 'components/CreateOrderForm';
import { Helmet } from 'react-helmet';
import { useCanManage } from 'hooks/useCanManage';
import { HandleFieldKey, HandleFieldValue } from 'components/CreateOrderForm/types';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import { EmployeeSelection } from 'components/EmployeeSelection';
import { useElementSize } from '@mantine/hooks';

export const CreateOrder: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const canManage = useCanManage();
  const { infoOrderDetail } = useSelector((state: RootState) => state.ordersDetailsSlice);
  const [errorCountDescription, setErrorCountDescription] = useState(false);
  const { ref, width } = useElementSize();
  const { errors, validateFields, validateDraftAmount, clearErrorForField, clearError } =
    useOrderValidation();

  const {
    handleSubmit,
    isLoading: submitLoading,
    apiError,
    setApiError,
  } = useOrderSubmission();

  const handleFieldChange = useCallback(
    (key: HandleFieldKey, value: HandleFieldValue) => {
      dispatch(setInfoOrderDetail({ key, value }));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!canManage) {
      navigate('/orders');
    }
  }, [canManage, navigate]);

  if (!infoOrderDetail) {
    return (
      <Layout>
        <div style={{ width: '100%' }}>
          <LoadingSkeleton fullWidth />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <Helmet>
        <title>Создать заказ</title>
      </Helmet>
      <div>
        <Link to='/orders' className={styles.backBtn}>
          <BackBtn />
          Назад к заказам
        </Link>

        <OrderSteps
          saveOrder={() =>
            handleSubmit(
              false,
              validateFields,
              validateDraftAmount,
              errorCountDescription,
            )
          }
          saveDraft={() =>
            handleSubmit(true, validateFields, validateDraftAmount, errorCountDescription)
          }
          isLoadingCreateOrder={submitLoading}
        />

        <div className={`${styles.main} ${width < 1000 ? styles.column : ''}`} ref={ref}>
          <CreateOrderForm
            setErrorCountDescription={setErrorCountDescription}
            handleFieldChange={handleFieldChange}
            errors={errors}
            clearErrorForField={clearErrorForField}
            clearError={clearError}
          />
          <EmployeeSelection />
        </div>
      </div>
      {apiError && (
        <SuccessErrorInfo
          text={apiError}
          type='error'
          handleClose={() => setApiError(null)}
        />
      )}
    </Layout>
  );
};
